import React from 'react'
import { Container, Alert } from 'react-bootstrap'
import { userManager } from 'auth/services/auth.service'
import { CircleSpinner } from '../../components/Spinners'
import { checkIsMobile } from 'utils/helpers'

function LogoutPage() {
	const [error, setError] = React.useState<Error>()

	async function logout() {
		const user = await userManager.getUser()

		if (Boolean(user)) {
			userManager.signoutRedirect({
				id_token_hint: sessionStorage.getItem('id_token'),
			})
			await userManager.clearStaleState()
		}
	}

	React.useEffect(
		() => {
			logout()
		},
		// eslint-disable-next-line
		[]
	)

	const classNames = [
		'spinner-container',
		'd-flex',
		'justify-content-center',
		'align-items-center',
	]
	classNames.push(checkIsMobile() ? '' : 'logout')

	return (
		<Container className={classNames.join(' ')}>
			{error ? (
				<Alert
					variant="danger"
					dismissible
					onClose={() => setError(undefined)}>
					{error.message}
				</Alert>
			) : (
				<CircleSpinner />
			)}
		</Container>
	)
}

export default LogoutPage